<template>
	<ul class="listItems" ref="listView">
		<li v-for="(j, resetIndexKey) in displayList" :key="resetIndexKey" @click="createDetail(j ,resetIndexKey)" @keyup.enter="createDetail(j ,resetIndexKey)" class="pageLink" tabindex="0">

				<template v-if="isEquipment">
<!--設備リスト -->
<p class="_process">{{j.process}}</p>
<p class="_title">{{j.title}}</p>
<p class="_maker">{{j.maker}}</p>
<p class="_image"><img-plus :img-src="j.image" :img-thumb="j.thumb" :img-alt="j.alt" :full-screen="true" at-place="list" /></p>
<p class="_remarks" v-text="j.remarks"></p>
<p class="_factory">{{j.factory}}</p>
<p class="_number">{{j.number}}</p>
				</template>

				<template v-else-if="isProducts">
<!--事例リスト -->
<!--映像とpdfは表示していない-->
<img :src="setThumbImage(j, true)" :alt="j.alt" ref="setImage" class="thumbPicture" v-on:load="imgLoaded">
<span>{{j.title}}</span>
				</template>

				<template v-else-if="isAnnounce">
<!--お知らせリスト -->
<article :id="j.id">
	<div class="articleContent">
    <p class="_date">{{isoDateToDisplayDate(j.date)}}</p>
		<h1 class="_title">{{j.title}}</h1>
		<p class="_note">wrote by {{j.note}}</p>
		<p class="_image"><img-plus :img-src="j.image" :img-thumb="j.thumb" :img-alt="j.alt" :full-screen="true" at-place="list" get-outside="" /></p>
		<p class="_content" v-html="replaceBr(j.content)"></p>
		<div class="articleContentLine">
			<p class="_link" v-if="isAnyLink(j.link)" @mouseenter.stop="addLinkIcon(j.link, $event)" @mouseleave.stop="deleteLinkIcon" @click.stop="toAnyPage(j.link, j.landing)">関連リンク：{{j.label}}</p>
		</div>
	</div>
</article>
				</template>

				<template v-else-if="isMaterial">
<!--素材リスト -->
<p class="_note">{{j.note}}</p>
<p class="_title">{{j.title}}</p>
<p class="_material">{{j.material}}</p>
<p class="_remarks">{{j.remarks}}</p>
<p class="_budget" v-if="isValue(j.thickness)">{{j.thickness}} x {{j.size}}<br><span class="">※価格は、[Tips]リンクサイトを参照ください。</span></p>
<p class="_budget" v-else></p>
				</template>

				<template v-else-if="isOfficial">
<!--公式文章リスト-->
<!--
<article>
  <div class="_block" :id="uniqueId(j.number)">
<p class="_date">{{isoDateToDisplayDate(j.date)}}</p>
<h1 class="_title">{{j.title}}</h1>
<p class="_image" @click="previewPdf(setImageFullPath(j.image))"><img-plus :img-src="j.image" :img-thumb="j.thumb" :img-alt="j.alt" :full-screen="true" at-place="list" get-outside="" /><p>
<p class="_content">{{j.content}}</p>
<p class="_category"><span>{{j.category}}</span></p>
  </div>
</article>
-->
<article :id="j.id">
	<div class="articleContent">
		<p class="_image"><img-plus :img-src="j.image" :img-thumb="j.thumb" :img-alt="j.alt" :full-screen="true" at-place="list" get-outside="" /></p>
		<div class="_grid">
			<h1 class="_title">{{j.title}}</h1>
			<p class="_date">{{isoDateToDisplayDate(j.date)}}</p>
			<p class="_category">{{j.category}}</p>
			<p class="_content" v-html="replaceBr(j.content)"></p>
			<div class="articleContentLine">
				<p class="_link" v-if="isAnyLink(j.link)" @mouseenter.stop="addLinkIcon(j.link, $event)" @mouseleave.stop="deleteLinkIcon" @click.stop="toAnyPage(j.link, j.landing)">関連リンク：{{j.label}}</p>
			</div>
		</div>
	</div>
</article>
				</template>

		</li>
	</ul>
</template>

<script>
import imgPlus from '@/components/ImgPlus.vue'

export default {
  name: 'anylist',
  props:{
    displayList: {
        type:Array,
    },
		anyList: {
			type:Number,
		},
		reDisplay: {
			type:Boolean,
		}
  },
  data: function () {
    return {
      imagesLoadedCount:0,
      detailIndex:0,
			resetIndexKey:0,   //コンポーネント再構築用に、外部から操作できるように定義する
    }
  },
  components:{
    imgPlus,
  },
  computed: {
		isEquipment:function() {
			return this.anyList === 1
		},
		isProducts:function() {
			return this.anyList === 2
		},
		isAnnounce:function() {
			return this.anyList === 3
		},
		isMaterial:function() {
			return this.anyList === 4
		},
		isOfficial:function() {
			return this.anyList === 5
		},
	},
  mounted:function() {this._log("mounted "+this.$options.name)
    //イメージ読み込み監視用
    //this.imagesLoadedCount = this.displayList.length
	},
	beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)
    //イメージ読み込み監視用
    //this.imagesLoadedCount = this.displayList.length
	},
	updated:function() {this._log("updated "+this.$options.name)
    //イメージ読み込み監視用
    this.imagesLoadedCount = this.displayList.length
//this._log("LOAD NUMBER", this.imagesLoadedCount)
	},
  methods:{
		isValue:function(value) {
			return value !== null
		},
		overLimit:function(aText) {
			return aText.length >= 80
		},
    uniqueId(aNumber) {
//IDなので、頭は大文字にする
			let pageName = this.$options.name
      return pageName.charAt(0).toUpperCase() + pageName.slice(1).toLowerCase() + aNumber
    },
    setThumbImage: function(i, flag) {
      let res = ""
      if(!i.thumb) {
        res = i.image
      } else {
        res = i.thumb
      }
//img src=の処理の場合は以下が必要
			if(flag) {
				res = (res ==="")? "":this.getInnerImageDir() + res
			}
      return res
    },
		isMov:function(aObject, aThumb) {
			let aSetUrl = null
			if((aObject != null) &&(aObject.toLowerCase().indexOf(".mp4") !== -1)) {
					aSetUrl = aThumb
			}
			return aSetUrl
		},
    createDetail(aImg, index) {
      this.$emit('createDetail', aImg, index)
		},
		imgLoaded:function(e) {
//this._log("imgLoaded", e)
/*
			let aAspectRatio = e.target.naturalWidth / e.target.naturalHeight
			let aParent = e.target.parentElement
			aParent.style.width = (aAspectRatio * 240).toFixed(6) + "px"
*/
			//カウンターアップ（実際はカウントダウン）
			this.imagesLoadedCount -= 1
			if(this.anyList === 2) {
				if(this.imagesLoadedCount == 1) {
//					this.correctRow()
			this.$emit('preparedImage')
				}
			}
    },
    moving:function(e) {
      e.target.classList.add("moving")
    },
    stopped:function(e) {
      e.target.classList.remove("moving")
    },
		resetComponent:function() {
//this._log("resetComponent", this.displayList)
/*検索/順序入れかえ時親から呼び出すための関数*/
/*correctRowを呼び出す前に、<li>にimage高さに合わせた（240px）幅をセットする必要がある*/		
			this.resetIndexKey = 0
		},
		resetItems:function() {
//表示要素を切り替える際の仮レイアウト状態を見えないようにする
      let aUlObject = this.$refs.listView
			let aItemsCount = aUlObject.childElementCount
			for(let index=0; index < aItemsCount; index++) {
				aUlObject.children[index].style.width = 0;
			}
		},
    correctRow:function() {
//並び要素の横サイズから、現在のwindowサイズでのレイアウト調整を行う
//レイアウト基準の高さは240pxとしている
      let basisHeight = 240
			let marginRight = 8 //px
			let maxHeight = basisHeight * 1.5 //最大縦サイズ360pxとする
//調整は、次オブジェクトwidth加算時、加算前後で幅サイズへの差分比較で行う

      let windowWidth = document.documentElement.clientWidth  //表示エリアサイズで
			if(windowWidth > 991) {
				windowWidth = windowWidth *0.8
			} else {
				windowWidth = windowWidth *0.9
			}
      let aRowTotalWidth = 0 //行ごとの幅合計値保持
      let aRowStartObjectIndex = 0 //行構成オブジェクトindex開始番号
			let aRowObjectsCount = 0			//行あたりのオブジェクト数
      let aNextRowTotalWidth = 0
      let aObjectsArray = this.$refs.setImage
      let aValue = {}
			let aAspectRatio, aParent
      let aShortWidth, aLongWidth, aRowAspectRatio, aRateWidth, aChangeHeight, aTargetObject, aWidth

			let aSetWidthValue, aSetHeightValue

      for(let index = 0; index < aObjectsArray.length; index++) {
        aValue = aObjectsArray[index]

//ここで親<li>の情報をセットする
				aAspectRatio = aValue.naturalWidth / aValue.naturalHeight
				aParent = aValue.parentElement
				aParent.style.width = (aAspectRatio * basisHeight).toFixed(6) + "px"
				aParent.style.height = basisHeight.toFixed(6) + "px"

//imgタグ自体に元サイズをセットする（並び替えのためには不要。SEOチェック対策）
				aSetWidthValue = aValue.naturalWidth
				aSetHeightValue = aValue.naturalHeight
				aValue.setAttribute('width', aSetWidthValue)
				aValue.setAttribute('height', aSetHeightValue)

				aNextRowTotalWidth = aRowTotalWidth + parseInt(aValue.parentElement.style.width)
        if(aNextRowTotalWidth > windowWidth) {
//this._log("オーバー")
//加算前後のwindow幅への+-差分を算出する
//加算しない場合の値
          aShortWidth = windowWidth - aRowTotalWidth
//加算した場合の値
          aLongWidth = aNextRowTotalWidth - windowWidth
//行オブジェクトの縦横比の計算用
//          aRowAspectRatio = 1
          aChangeHeight = basisHeight

          if(aShortWidth > aLongWidth) {
//加算した状態で高さ調整へ
            aRowTotalWidth += parseInt(aValue.parentElement.style.width)
						aRowObjectsCount = index+1-aRowStartObjectIndex -1
						aRowTotalWidth +=  marginRight * aRowObjectsCount  //横マージン間数分加算する

//            aRowAspectRatio = aRowTotalWidth / basisHeight
            aRateWidth = aRowTotalWidth / windowWidth  //縮小/拡大比率
            aChangeHeight = windowWidth / aRowTotalWidth * basisHeight //表示エリア横サイズに収めた場合の高さ算出
//対象オブジェクトに変更縦横サイズをセットしていく

//this._log("加算して")
            for(let j = aRowStartObjectIndex; j < index+1; j++) {
              aTargetObject = aObjectsArray[j].parentElement
//高さを調整
              aTargetObject.style.height = aChangeHeight.toFixed() + "px"
//幅を調整
              aWidth = parseInt(aTargetObject.style.width)
              aTargetObject.style.flexGrow = "0"
              aTargetObject.style.flexShrink = "1"
              aTargetObject.style.flexBasis = Math.floor(aWidth / aRateWidth).toString() + "px"
//aTargetObject.style.backgroundColor = "#112233"
            }
            aRowTotalWidth = 0
						aRowStartObjectIndex = index+1
          } else {
//this._log("加算しない")
						aRowObjectsCount = index-aRowStartObjectIndex -1
						aRowTotalWidth +=  marginRight * aRowObjectsCount  //横マージン間数分加算する

//加算しない状態で高さ調整へ
//            aRowAspectRatio = aRowTotalWidth / basisHeight
            aRateWidth = aRowTotalWidth / windowWidth  //縮小/拡大比率
            aChangeHeight = windowWidth / aRowTotalWidth * basisHeight //表示エリア横サイズに収めた場合の高さ算出
//対象オブジェクトに変更縦横サイズをセットしていく 
            for(let k = aRowStartObjectIndex; k < index; k++) {
              aTargetObject = aObjectsArray[k].parentElement
//高さを調整
              aTargetObject.style.height = aChangeHeight.toFixed() + "px"
//幅を調整
              aWidth = parseInt(aTargetObject.style.width)
              aTargetObject.style.flexGrow = "0"
              aTargetObject.style.flexShrink = "1"
              aTargetObject.style.flexBasis = Math.floor(aWidth / aRateWidth).toString() + "px"
//aTargetObject.style.backgroundColor = "#445566"
            }
//次の情報をセットする
            aRowTotalWidth = parseInt(aValue.parentElement.style.width)
            aRowStartObjectIndex = index
          }

        } else if(aNextRowTotalWidth == windowWidth) {
//this._log("等しい")
//ありえないけど、等しい場合の処理
          aRowTotalWidth = 0
          aRowStartObjectIndex = index
        } else {
//this._log("満たない")
//通常の継続処理
          aRowTotalWidth += parseInt(aValue.parentElement.style.width)
//満たない、の漏れ
//横幅、行内に複数配置可能な場合、最後のイメージ
//横幅、行内に一つしか配置できない場合、イメージ
        }

//最後の要素に対しての処理
				if( index+1 == aObjectsArray.length) {
//this._log("LAST OBJECT")
						aRowObjectsCount = index+1-aRowStartObjectIndex -1
						aRowTotalWidth +=  marginRight * aRowObjectsCount  //横マージン間数分加算する

//					aRowAspectRatio = aRowTotalWidth / basisHeight
					aRateWidth = aRowTotalWidth / windowWidth  //縮小/拡大比率
					aChangeHeight = windowWidth / aRowTotalWidth * basisHeight //表示エリア横サイズに収めた場合の高さ算出

//縦サイズがmaxHeightを超えた場合は、縦maxHeightを基本に補正する
					if(aChangeHeight > maxHeight) {
						aRateWidth =   basisHeight / maxHeight
						aChangeHeight = maxHeight
					}

					for(let k = aRowStartObjectIndex; k < index+1; k++) {
						aTargetObject = aObjectsArray[k].parentElement
//高さを調整
						aTargetObject.style.height =  aChangeHeight.toFixed() + "px"  //basisHeight
//this._log(aTargetObject )
//幅を調整
						aWidth = parseInt(aTargetObject.style.width)
//this._log(aWidth)
//this._log(aChangeHeight)
						aTargetObject.style.flexGrow = "0"
						aTargetObject.style.flexShrink = "1"
						aTargetObject.style.flexBasis = Math.floor(aWidth / aRateWidth).toString() + "px"
//this._log(aTargetObject )
					}
//            aRowTotalWidth = 0
//						aRowStartObjectIndex = index+1
				}

      }
			this.$emit('changedDsp')
    },
  },
}
</script>


<style>
</style>
